import React from "react";
import {
  Create,
  SimpleForm,
  FileField,
  Toolbar,
  FileInput,
  ListButton,
  SaveButton,
  DateInput,
  TextInput

} from "react-admin";
import { onUploadWithdrawPaymentInfonewCreate } from "../../Service/Validation/AddBonusValidation";
import Grid from "@material-ui/core/Grid";
import { WithdrawPaymentInfonewSelectInput } from "../../UI/Input/SelectInput";

const PageTitle = () => {
  return <span> Refund user staff id upload</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AddWithdrawPaymentInfonewCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onUploadWithdrawPaymentInfonewCreate}>
        <SanitizedGrid container spacing={3} fullWidth>
        
          <Grid item sm={12} md={12} lg={12}>

          <WithdrawPaymentInfonewSelectInput  label="Select Type" fullWidth source="type"/>
          </Grid>
         
          <FileInput source="attachments">
            <FileField source="src" title="title" />
          </FileInput>


        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default AddWithdrawPaymentInfonewCreate;
